import { render, staticRenderFns } from "./KycGroups.vue?vue&type=template&id=dcd3ed14"
import script from "./KycGroups.vue?vue&type=script&lang=js"
export * from "./KycGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports